module.exports = __webpack_public_path__ + "img/Logo-14.549f7911.svg";